export const TABLE_COLUMNS = {
	priority: { id: 'priority', priority: 3, title: 'priority', condition: '' },
	way_points: { id: 'way_points', priority: 4, title: 'orderType', condition: '' },
	external_id: { id: 'external_id', priority: 5, title: 'orderId', condition: '' },
	customerName: { id: 'customerName', priority: 6, title: 'customerName', condition: '' },
	eta: { id: 'eta', priority: 7, title: 'eta', condition: '' },
	timeWindow: { id: 'timeWindow', priority: 8, title: 'timeWindow', condition: '' },
	etos: { id: 'etos', priority: 9, title: 'etos', condition: '' },
	skills: { id: 'skills', priority: 10, title: 'skills', condition: 'enableSkills' },
	total_weight: { id: 'total_weight', priority: 11, title: 'weight', condition: '' },
	max_handling_units: { id: 'max_handling_units', priority: 12, title: 'handlingUnits', condition: 'enableVehicles' },
	rank: { id: 'rank', priority: 13, title: 'rank', condition: '' },
	totalPrice: { id: 'totalPrice', priority: 14, title: 'totalPrice', condition: 'enableTaskPrice' },
	sla: { id: 'sla', priority: 15, title: 'sla', condition: '' }
};

export const TABLE_STATIC_COLUMNS = {
	colorMark: { id: 'colorMark', priority: 1 },
	id: { id: 'id', priority: 2 }
};
